const VoucherTypeEnum = Object.freeze({
    E_VOUCHER: 1,
    PHYSICAL_VOUCHER: 2,
});

export default VoucherTypeEnum;
